export const JWT_STORAGE_KEY = "jwt";
export const ONBOARDING_STORAGE_KEY = "mls2_onboarding_complete";

export function requireAuth(): string | null {
  return localStorage.getItem(JWT_STORAGE_KEY);
}

export function storeAuth(jwt: string): void {
  localStorage.setItem(JWT_STORAGE_KEY, jwt);
}

export function clearAuth(): void {
  localStorage.removeItem(JWT_STORAGE_KEY);
}

export function hasCompletedOnboarding(): boolean {
  return localStorage.getItem(ONBOARDING_STORAGE_KEY) === "true";
}

export function completeOnboarding(): void {
  localStorage.setItem(ONBOARDING_STORAGE_KEY, "true");
}
